var map = {
	"./20210801120724899_b.jpg": 376,
	"./20210809_122745_3589.jpg": 377,
	"./7z.png": 378,
	"./Group_1.png": 99,
	"./Group_12.png": 379,
	"./Logo_x3.png": 380,
	"./No-image.jpg": 381,
	"./angular.jpg": 382,
	"./avi.png": 383,
	"./bootstrap.jpg": 384,
	"./calendar.png": 112,
	"./component-btn-pink.png": 385,
	"./component-btn.png": 386,
	"./component-info-2.png": 387,
	"./component-info-card.png": 388,
	"./component-menu.png": 389,
	"./component-profile-card.png": 390,
	"./doc.png": 391,
	"./documentation.png": 392,
	"./gif.png": 393,
	"./github.svg": 394,
	"./google.svg": 395,
	"./ill_header.png": 396,
	"./images.jpg": 397,
	"./jpg.png": 398,
	"./landing.jpg": 399,
	"./login.jpg": 400,
	"./m3u.png": 401,
	"./menu1.png": 132,
	"./menu2.png": 133,
	"./menu3.png": 134,
	"./menu4.png": 135,
	"./menu5.png": 136,
	"./mju-logo.png": 402,
	"./mkv.png": 403,
	"./mp3.png": 404,
	"./mp4.png": 405,
	"./mpeg.png": 406,
	"./no-image-3.jpg": 407,
	"./no-image-available_1.png": 408,
	"./no-img-2.jpg": 166,
	"./no-pic.jpg": 409,
	"./noimg.png": 26,
	"./pattern_react.png": 410,
	"./pdf.png": 411,
	"./planting.png": 113,
	"./png.png": 412,
	"./ppt.png": 413,
	"./processing.png": 114,
	"./profile.jpg": 414,
	"./rar.png": 415,
	"./react.jpg": 416,
	"./register_bg_2.png": 417,
	"./sketch.jpg": 418,
	"./team-1-800x800.jpg": 167,
	"./team-2-800x800.jpg": 168,
	"./team-3-800x800.jpg": 169,
	"./team-4-470x470.png": 170,
	"./txt.png": 419,
	"./vue.jpg": 420,
	"./wav.png": 421,
	"./wmv.png": 422,
	"./xls.png": 423,
	"./zip.png": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;